import { IOpenAuthModalParameters } from '../../repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';
import { TThunkAction } from '../../types/redux';

export function openAuthenticationModal(parameters: IOpenAuthModalParameters = {}): TThunkAction {
  return (_dispatch, _getState, { logger, microfrontendsAPI }) => {
    if (!microfrontendsAPI) {
      return;
    }

    microfrontendsAPI.header
      .openAuthModal({
        autoRefresh: false,
        alert: null,
        useDefaultView: false,
        viewData: null,
        source: null,
        ...parameters,
      })
      .catch(error => {
        logger.error(error, { degradation: 'Открытие модального окна авторизации' });
      });
  };
}
